export default __webpack_public_path__ + "static/media/Vietnam.6397b873.svg";